import React, { Component } from "react";
import {
  Accordion,
  Button,
  Container,
  Grid,
  Input,
  Radio,
  Segment
} from "semantic-ui-react";

import { AppContext } from "../../utils/context";
import request from "../../utils/request";
import JackpotList from "./JackpotList";
import JackpotElements from "../../components/jackpot/JackpotElements";
import TextForm, { Arial } from "../../components/content/JackpotTextForm";
import ImageForm from "../../components/content/JackpotImageForm";

let textElement = {
  color: "#333333",
  display: "block",
  fontFamily: Arial,
  fontSize: "96px",
  fontWeight: "bold",
  height: "auto",
  left: "0px",
  lineHeight: "110px",
  position: "absolute",
  textAlign: "center",
  top: "0px",
  content: "Text",
  caption: "",
  captionPosition: "top",
  label: "Text",
  type: "text",
  editable: true
};

let imageElement = {
  backgroundImage: `url(https://via.placeholder.com/300)`,
  backgroundRepeat: "no-repeat",
  backgroundAttachment: "scroll",
  backgroundPosition: "center center",
  backgroundSize: "cover",
  display: "block",
  position: "absolute",
  content: "",
  label: "Image",
  type: "image",
  editable: true,
  height: "300px",
  left: "0px",
  top: "0px",
  width: "300px"
};

let backgroundElement = { ...imageElement };
backgroundElement.width = "100%";
backgroundElement.height = "100%";
backgroundElement.backgroundColor = "#ffffff";
backgroundElement.backgroundImage = "none";
backgroundElement.backgroundRepeat = "no-repeat";
backgroundElement.backgroundAttachment = "scroll";
backgroundElement.backgroundPosition = "center center";
backgroundElement.backgroundSize = "contain";
backgroundElement.overflow = "hidden";
backgroundElement.label = "Background";
backgroundElement.type = "background";

let jackpotElement = { ...textElement};
jackpotElement.label = "Jackpot";
jackpotElement.content = "$000,000";
jackpotElement.caption = "Total Jackpot";
jackpotElement.editable = false;
jackpotElement.top = "80px";
jackpotElement.fontSize = "196px";
jackpotElement.lineHeight = "210px";

let prizeElement = { ...textElement };
prizeElement.label = "Prize";
prizeElement.caption = "Estimated Prize";
prizeElement.content = "$00,000";
prizeElement.color = "#333333";
prizeElement.editable = false;
prizeElement.top = "480px";
prizeElement.fontSize = "154px";
prizeElement.lineHeight = "168px";

let weeklyJackpotElement = { ...textElement };
weeklyJackpotElement.label = "Weekly Jackpot";
weeklyJackpotElement.caption = "Weekly Jackpot";
weeklyJackpotElement.content = "$00,000";
weeklyJackpotElement.color = "#333333";
weeklyJackpotElement.editable = false;
weeklyJackpotElement.top = "480px";
weeklyJackpotElement.fontSize = "154px";
weeklyJackpotElement.lineHeight = "168px";

let winnerElement = { ...textElement };
winnerElement.label = "Winning Number";
winnerElement.caption = "Winning Number";
winnerElement.captionPosition = "left";
winnerElement.content = "00000000";
winnerElement.color = "#333333";
winnerElement.editable = false;
winnerElement.top = "900px";
winnerElement.fontSize = "126px";
winnerElement.lineHeight = "140px";
winnerElement.hideCaptionUntilDraw = false;

let dateElement = { ...textElement };
dateElement.label = "Raffle Date";
dateElement.caption = "Raffle Date";
dateElement.captionPosition = "left";
dateElement.content = "202x-xx-xx";
dateElement.color = "#333333";
dateElement.editable = false;
dateElement.top = "900px";
dateElement.fontSize = "126px";
dateElement.lineHeight = "140px";

// Addon Elements
let addonJackpotElement = { ...textElement};
addonJackpotElement.label = "Addon Jackpot";
addonJackpotElement.content = "$000,000";
addonJackpotElement.caption = "Addon Total Jackpot";
addonJackpotElement.editable = false;
addonJackpotElement.top = "80px";
addonJackpotElement.fontSize = "4.5rem";
addonJackpotElement.lineHeight = "4.6rem";

let addonPrizeElement = { ...textElement };
addonPrizeElement.label = "Addon Prize";
addonPrizeElement.caption = "Estimated Addon Prize";
addonPrizeElement.content = "$00,000";
addonPrizeElement.color = "#333333";
addonPrizeElement.editable = false;
addonPrizeElement.top = "180px";
addonPrizeElement.fontSize = "4rem";
addonPrizeElement.lineHeight = "4rem";

let addonWinnerElement = { ...textElement };
addonWinnerElement.label = "Addon Winning Number";
addonWinnerElement.caption = "Addon Winning Number";
addonWinnerElement.captionPosition = "left";
addonWinnerElement.content = "00000000";
addonWinnerElement.color = "#333333";
addonWinnerElement.editable = false;
addonWinnerElement.top = "280px";
addonWinnerElement.fontSize = "4rem";
addonWinnerElement.lineHeight = "4rem";
addonWinnerElement.hideCaptionUntilDraw = false;

let addonDateElement = { ...textElement };
addonDateElement.label = "Addon Raffle Date";
addonDateElement.caption = "Addon Raffle Date";
addonDateElement.captionPosition = "left";
addonDateElement.content = "202x-xx-xx";
addonDateElement.color = "#333333";
addonDateElement.editable = false;
addonDateElement.top = "280px";
addonDateElement.fontSize = "4rem";
addonDateElement.lineHeight = "4rem";


let defaultElements = [jackpotElement, winnerElement];

function arrayMove(arr, old_index, new_index) {
  if (new_index > arr.length) {
    return arr;
  }
  arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
  return arr; // for testing
}

const ElementHeader = props => (
  <Button.Group fluid>
    <Button
      icon="arrow up"
      content="Move up"
      onClick={e => props.move(props.id, props.id - 1)}
    />
    <Button
      icon="arrow down"
      content="Move down"
      onClick={e => props.move(props.id, props.id + 1)}
    />
  </Button.Group>
);

class Jackpot extends Component {
    constructor(props, context) {
        super(props);
        let jackpotKioskDisplayUnit = context?.settings?.general?.jackpot_kiosk_display_unit ?? "absolute";
        const isRelative = jackpotKioskDisplayUnit === "relative";

        textElement.fontSize = isRelative ? "10rem" : "95px";
        textElement.left = isRelative ? "0vw" : "0px";
        textElement.lineHeight = isRelative ? "15vh" : "95px";
        textElement.top = isRelative ? "10vh" : "0px";

        imageElement.height = isRelative ? "30vh" : "300px";
        imageElement.left = isRelative ? "0vw" : "0px";
        imageElement.top = isRelative ? "0vh" : "0px";
        imageElement.width = isRelative ? "30vw" : "300px";

        jackpotElement.top = isRelative ? "10vh" : "80px";
        jackpotElement.fontSize = isRelative ? "10rem" : "190px";
        jackpotElement.lineHeight = isRelative ? "15vh" : "190px";
        jackpotElement.left = isRelative ? "30vw" : "650px";

        prizeElement.top = isRelative ? "40vh" : "480px";
        prizeElement.fontSize = isRelative ? "10rem" : "150px";
        prizeElement.lineHeight = isRelative ? "15vh" : "150px";
        prizeElement.left = isRelative ? "30vw" : "650px";

        weeklyJackpotElement.top = isRelative ? "40vh" : "480px";
        weeklyJackpotElement.fontSize = isRelative ? "10rem" : "150px";
        weeklyJackpotElement.lineHeight = isRelative ? "15vh" : "150px";
        weeklyJackpotElement.left = isRelative ? "30vw" : "650px";

        winnerElement.top = isRelative ? "70vh" : "900px";
        winnerElement.fontSize = isRelative ? "10rem" : "125px";
        winnerElement.lineHeight = isRelative ? "15vh" : "125px";
        winnerElement.left = isRelative ? "0vw" : "0px";

        dateElement.top = isRelative ? "80vh" : "900px";
        dateElement.fontSize = isRelative ? "15rem" : "125px";
        dateElement.lineHeight = isRelative ? "22.5vh" : "125px";
        dateElement.left = isRelative ? "30vw" : "650px";

        addonJackpotElement.top = isRelative ? "10vh" : "80px";
        addonJackpotElement.fontSize = isRelative ? "10rem" : "190px";
        addonJackpotElement.lineHeight = isRelative ? "15vh" : "190px";
        addonJackpotElement.left = isRelative ? "30vw" : "650px";

        addonPrizeElement.top = isRelative ? "40vh" : "480px";
        addonPrizeElement.fontSize = isRelative ? "10rem" : "150px";
        addonPrizeElement.lineHeight = isRelative ? "15vh" : "150px";
        addonPrizeElement.left = isRelative ? "30vw" : "650px";

        addonWinnerElement.top = isRelative ? "70vh" : "900px";
        addonWinnerElement.fontSize = isRelative ? "10rem" : "125px";
        addonWinnerElement.lineHeight = isRelative ? "15vh" : "125px";
        addonWinnerElement.left = isRelative ? "0vw" : "0px";

        addonDateElement.top = isRelative ? "80vh" : "900px";
        addonDateElement.fontSize = isRelative ? "15rem" : "125px";
        addonDateElement.lineHeight = isRelative ? "22.5vh" : "125px";
        addonDateElement.left = isRelative ? "30vw" : "650px";

        this.state = {
            loading: false,
            background: backgroundElement,
            elements: defaultElements,
            activeIndex: 0,
            id: 0,
            active: true,
            name: "",
            dataSrc: "",
            isRelative: isRelative
        }
    }
  componentDidMount = () => {
    this.getData();
  };
  componentDidUpdate = prevProps => {
    if (this.props.match !== prevProps.match) {
      this.getData();
    }
  };
  componentWillUnmount = () => {
    this.setState({
      loading: false,
      background: backgroundElement,
      elements: defaultElements,
      activeIndex: 0,
      id: 0,
      active: true,
      name: "",
      dataSrc: ""
    });
  };
  isLoaded = (jackpotId) => {
    let self = this;
    self.setState({ loading: false });
    if (jackpotId) {
      let history = this.props.history;
      let url = `/content-manager/jackpot`;
      history.replace(url);
    }
  };
  startLoading = () => {
    this.setState({ loading: true })
  }
  doneLoading = () => {
    this.setState({ loading: false })
  }

  // Function converts relative values to absolute
  convertRelToAbs  = (elem, vpType, windowDisplay, maxRel = 99999, maxAbs = 99999) => {
    if (!this.state.isRelative && elem.includes(vpType)) {
      if (maxRel === 99999 && maxAbs === 99999) {
        return ((parseInt(elem.replace(vpType, "")) * windowDisplay) / 100) + 'px'
      }
      const difference = parseInt(elem.replace(vpType, "")) / maxRel
      const absoluteValue = difference * maxAbs
      if (Math.floor(absoluteValue) > maxAbs) return maxAbs + 'px'
      else return Math.floor(absoluteValue) + 'px'
    } else return elem
  };

  // Function converts absolute values to relative
  convertAbsToRel  = (elem, vpType, windowDisplay, maxRel = 99999, maxAbs = 99999) => {
    if (this.state.isRelative && elem.includes('px')) {
      if (maxRel === 99999 && maxAbs === 99999) {
        const relValue = (100 * parseInt(elem.replace('px', ""))) / windowDisplay
        return relValue.toFixed(1) + vpType
      }

      const difference = parseInt(elem.replace(vpType, "")) / maxAbs
      const relativeValue = difference * maxRel
      return relativeValue.toFixed(1) + vpType
    } else return elem
  };

  getData = () => {
    let id = this.props.match.params.method;
    this.startLoading();
    if (id === undefined || id === "create") {
      this.setState({
        background: backgroundElement,
        elements: defaultElements,
        id: 0,
        active: true,
        name: "",
        dataSrc: ""
      }, () => this.doneLoading());
      return false;
    }
    return request
      .get(this, `api:/content/jackpot-screen/${id}`)
      .then(resp => {
        // for saved Jackpots, convert relative to absolute
        const elem = JSON.parse(resp.elements)
        const maxRelativeLeft = 60
        const maxAbsoluteLeft = 1300
        const maxRelativeTop = 80
        elem.forEach(e => {
          if (e["lineHeight"] == null) {
            e["lineHeight"] = this.state.isRelative ? "20vh" : "140px"
          }
          e['lineHeight'] = this.convertRelToAbs(e['lineHeight'], 'vh', window.innerHeight)
          const maxAbsoluteTop = String(1080 - e["lineHeight"].replace("px", ""))
          if (!(this.state.isRelative && e['lineHeight'].includes('vh'))) {
            e['left'] = this.convertRelToAbs(e['left'], 'vw', window.innerWidth, maxRelativeLeft, maxAbsoluteLeft)
            e['top'] = this.convertRelToAbs(e['top'], 'vh', window.innerHeight, maxRelativeTop, maxAbsoluteTop)
            e['left'] = this.convertAbsToRel(e['left'], 'vw', window.innerWidth, maxRelativeLeft, maxAbsoluteLeft)
            e['lineHeight'] = this.convertAbsToRel(e['lineHeight'], 'vh', window.innerHeight)
            e['top'] = this.convertAbsToRel(e['top'], 'vh', window.innerHeight, maxRelativeTop, maxAbsoluteTop)
          }
        })

        resp && this.setState(
          {
            background: JSON.parse(resp.css),
            elements: elem,
            id: resp.id,
            active: +resp.active === 1 ? true : false,
            name: resp.name,
            dataSrc: resp.data_src
          },
          () => this.doneLoading()
        );
      });
  };
  addElement = elem => {
    let hasJackpot = 0;
    let hasPrize = 0;
    let elements = [...this.state.elements];
    elements.forEach(v => {
      if (v.label === "Jackpot") hasJackpot++;
      if (v.label === "Prize") hasPrize++;
    });
    if (elem.label === "Jackpot" && hasJackpot) return false;
    if (elem.label === "Prize" && hasPrize) return false;
    elements.push(elem);
    this.setState(
      { elements },
      () => this.handleAccordion(null, { index: elements.length })
    );
  };
  deleteElement = i => {
    let elements = [...this.state.elements];
    elements.splice(i, 1);
    this.setState({ elements }, () => this.handleAccordion(null, { index: -1 }));
  };
  deleteBackground = () => {
    let background = backgroundElement;
    this.setState({ background }, () => this.handleAccordion(null, { index: -1 }));
  };
  updateBackground = (i, prop, value) => {
    this.setState(prevState => ({
      ...prevState,
      background: {
        ...prevState.background,
        [prop]: value
      }
    }));
  };
  moveElement = (i, newKey) => {
    let elements = [...this.state.elements];
    elements = arrayMove(elements, i, newKey);
    this.setState(
      { elements },
      () => this.handleAccordion(null, { index: newKey + 1 })
    );
  };
  updateElement = (i, prop, value) => {
    let elements = [...this.state.elements];
    let props = { ...elements[i] };

    if (typeof prop === "object") {
      Object.keys(prop).map(v => {
        props[v] = prop[v];
        return props;
      });
    } else {
      if (prop == 'hideCaptionUntilDraw') {
        props[prop] = +!value;
      } else {
        props[prop] = value;
      }

    }
    elements[i] = props;
    this.setState({ elements });
  };
  handleAccordion = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;
    this.setState({ activeIndex: newIndex });
  };
  handleChange = (e, { name, value }) => this.setState({ [name]: value });
  handleSave = () => {
    const { id, name, active, background, elements, dataSrc } = this.state;
    let payload = {
      id: id,
      name: name,
      active: active,
      css: background,
      elements: elements,
      data_src: dataSrc
    };
    this.setState({ loading: true });
    request.post(this, "api:/content/jackpot-screen", payload).then(resp => {
      if (resp.status === "success") {
        this.isLoaded(resp.jackpotscreen);
      }
    });
  };
  handleToggle = (e, { name, value }) => this.setState({ [name]: !this.state[name] });
  handleUpload = (i, file) => {
    // Initial FormData
    let formData = new FormData();
    formData.append("name", file['name']);
    formData.append("img_file", file);
    formData.append("img_type", i);

    return request.post(this, "api:/content/upload-asset", formData).then(resp => {
      if (resp.status === "success") {
        let imgUrl = resp.data.url;
        let imgWidth = resp.data.width;
        let imgHeight = resp.data.height;

        if (i === "background") {
          let background = { ...this.state.background };
          background.backgroundImage = `url(${imgUrl})`;
          this.setState({ background });
        } else {
          if (imgWidth > imgHeight && imgWidth > 1920) {
            imgHeight = Math.ceil(imgHeight * (imgHeight / 1920));
            imgWidth = 1920;
          }
          if (imgHeight > imgWidth && imgHeight > 1080) {
            imgWidth = Math.ceil(imgWidth * (imgWidth / 1080));
            imgHeight = 1080;
          }

          this.updateElement(i, {
            backgroundImage: `url(${imgUrl})`,
            width: `${imgWidth}px`,
            height: `${imgHeight}px`
          });
        }
      }else if (resp.status === 'pixel_error') {
        alert(resp.error_message);
      } else {
        alert (resp.message);
      }
    });
  };
  render() {
    if (this.props.match.params.method === undefined) return <JackpotList />;
    const {
      active,
      activeIndex,
      background,
      elements,
      loading,
      name,
      dataSrc,
      isRelative
    } = this.state;

    document.body.style.zoom = "100%"; // this line may not work in firefox
    document.addEventListener("keydown", function (e) {
      if (e.ctrlKey && (e.key == "=" || e.key == "-")) {
        e.preventDefault();
      }
    });

    document.addEventListener("wheel", function (e) {
      if (e.ctrlKey) e.preventDefault();
    },
    {
      passive: false
    });

    let panels = [
      {
        key: `panel-0`,
        title: {
          content: "Background",
          onClick: this.handleAccordion
        },
        content: {
          content: (
            <ImageForm
              element={background}
              id={"background"}
              isRelative={isRelative}
              drop={this.handleUpload}
              update={this.updateBackground}
              delete={this.deleteBackground}
            />
          )
        }
      }
    ];
    elements.map((elem, i) => {
      let control = false;
      if (elem.type === "text")
        control = (
          <TextForm
            title={
              <ElementHeader
                id={i}
                title={elem.label}
                move={this.moveElement}
              />
            }
            element={elem}
            id={i}
            isRelative={isRelative}
            update={this.updateElement}
            delete={this.deleteElement}
          />
        );
      if (elem.type === "image")
        control = (
          <ImageForm
            title={
              <ElementHeader
                id={i}
                title={elem.label}
                move={this.moveElement}
              />
            }
            element={elem}
            id={i}
            isRelative={isRelative}
            drop={this.handleUpload}
            update={this.updateElement}
            delete={this.deleteElement}
          />
        );

      return panels.push({
        key: `panel-${i + 1}`,
        title: {
          content: elem.label,
          onClick: this.handleAccordion
        },
        content: {
          content: control
        }
      });
    });

    return (
      <Segment basic loading={loading}>
        <Grid>
          <Grid.Row>
            <Grid.Column width={5}>
              <Input
                label="Name"
                name="name"
                value={name ? name : ""}
                onChange={this.handleChange}
              />
              &nbsp;&nbsp;&nbsp;
              <Radio
                label="Active"
                toggle
                name="active"
                checked={active}
                onChange={this.handleToggle}
              />
            </Grid.Column>
            <Grid.Column width={5}>
              <Input
                label="XML Data Source"
                name="dataSrc"
                value={dataSrc ? dataSrc : ""}
                onChange={this.handleChange}
                fluid
              />
            </Grid.Column>
            <Grid.Column width={6}>
              <Button
                icon="save"
                content="Save"
                floated="right"
                primary
                onClick={this.handleSave}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={16}>
              <Button
                  icon="image"
                  content="Image"
                  floated="right"
                  onClick={e => this.addElement({ ...imageElement })}
                />
                <Button
                  icon="font"
                  content="Text"
                  floated="right"
                  onClick={e => this.addElement({ ...textElement })}
                />

                <Button
                  icon="clock"
                  content="Addon Date"
                  floated="right"
                  onClick={e => this.addElement(addonDateElement)}
                />
                <Button
                  icon="trophy"
                  content="Addon Winner"
                  floated="right"
                  onClick={e => this.addElement(addonWinnerElement)}
                />
                <Button
                  icon="trophy"
                  content="Addon Prize"
                  floated="right"
                  onClick={e => this.addElement(addonPrizeElement)}
                />
                <Button
                  icon="usd"
                  content="Addon Jackpot"
                  floated="right"
                  onClick={e => this.addElement(addonJackpotElement)}
                />

                <Button
                  icon="clock"
                  content="Date"
                  floated="right"
                  onClick={e => this.addElement(dateElement)}
                />
                <Button
                  icon="trophy"
                  content="Winner"
                  floated="right"
                  onClick={e => this.addElement(winnerElement)}
                />
                <Button
                  icon="trophy"
                  content="Prize"
                  floated="right"
                  onClick={e => this.addElement(prizeElement)}
                />
                <Button
                  icon="usd"
                  content="Weekly Jackpot"
                  floated="right"
                  onClick={e => this.addElement(weeklyJackpotElement)}
                />
                <Button
                  icon="usd"
                  content="Jackpot"
                  floated="right"
                  onClick={e => this.addElement(jackpotElement)}
                />
            </Grid.Column>
          </Grid.Row>
          <Grid.Column width={12}>
            <div
              style={{
                display: "block",
                transform: isRelative ? "scale(0.6, 0.6)" : "scale(0.5, 0.5)",
                transformOrigin: "top left"
              }}
            >
              <Segment compact inverted>
                <Container
                  style={{
                    position: "relative",
                    width: isRelative ? "100vw" : "1920px",
                    height: isRelative ? "100vh" : "1080px",
                    backgroundColor: "white",
                    border: "0.1rem solid white"
                  }}
                >
                  <JackpotElements
                    loading={loading}
                    background={background}
                    elements={elements}
                  />
                </Container>
              </Segment>
            </div>
          </Grid.Column>
          <Grid.Column width={4}>
            <Accordion fluid styled activeIndex={activeIndex} panels={panels} />
          </Grid.Column>
        </Grid>
      </Segment>
    );
  }
}

Jackpot.contextType = AppContext;
export default Jackpot;
